'use client';

import { exposeClassnames as classnames } from '@stadionhq-v3/utilities';
import { RichTextRenderer } from '@stadionhq-v3/contentful-ui';
import { Options } from '@contentful/rich-text-react-renderer';
import { ContentfulRichTextRenderProps } from './contentfulRichTextRender.types';
import { useContentfulRichTextRendererOptions as defaultOptions } from './useContentfulRichTextRendererOptions';
import styles from './contentfulRichTextRender.module.scss';

const ContentfulRichTextRender = ({
  as: Tag = 'div',
  nativeProps,
  classNames,
  document,
  locale,
  theme = {
    themeId: 'default1',
    title: 'Default Theme',
  },
  customRenderOptions,
  onDark,
  dictionary,
  packagePageLinkPath,
  compact,
}: ContentfulRichTextRenderProps) => {
  const classes = classnames(
    [styles.tokens, styles.contentfulRichTextRender, styles[theme.themeId]],
    { [`${styles.base2}`]: onDark },
    classNames
  );

  let options: Options = {
    ...defaultOptions({
      locale,
      links: document?.links,
      dictionary,
      onDark,
      theme,
      packagePageLinkPath,
      compact,
    }),
    preserveWhitespace: true,
  };

  if (customRenderOptions) {
    options = { ...options, ...customRenderOptions };
  }

  return (
    <Tag
      data-component="ContentfulRichTextRender"
      className={classes}
      {...nativeProps}
    >
      <RichTextRenderer
        document={document}
        customRenderOptions={options}
        classNames={[classnames(styles.rte)]}
      />
    </Tag>
  );
};

export default ContentfulRichTextRender;
